import { IItemForGetShortInfo, TFileId, IServerError, IUserEmailValidationError, ICreateUser } from 'types';
import { TSourceUrlLocally, TCreateUserSelectedItem, TTypeOfCreateUserModalWindow } from './createUserContext';

export enum CreateUserActionTypes {
	SET_FILE = 'SET_FILE',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_SURNAME = 'CHANGE_SURNAME',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_PHONE_NUMBER = 'CHANGE_PHONE_NUMBER',
	SET_ROLE = 'SET_ROLE',
	SET_FETCHED_ROLES = 'SET_FETCHED_ROLES',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_CUSTOMERS = 'SET_CUSTOMERS',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	CHANGE_PASSWORD = 'CHANGE_PASSWORD',
	CHANGE_PASSWORD_CONFIRM = 'CHANGE_PASSWORD_CONFIRM',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFile {
	type: CreateUserActionTypes.SET_FILE;
	payload: {
		fileId: TFileId;
		sourceUrlLocally: TSourceUrlLocally;
	};
}

interface IChangeName {
	type: CreateUserActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface IChangeSurName {
	type: CreateUserActionTypes.CHANGE_SURNAME;
	payload: {
		surName: string;
	};
}

interface IChangeEmail {
	type: CreateUserActionTypes.CHANGE_EMAIL;
	payload: {
		email: string;
	};
}

interface IChangePhoneNumber {
	type: CreateUserActionTypes.CHANGE_PHONE_NUMBER;
	payload: {
		phoneNumber: string;
	};
}

interface ISetFetchedRoles {
	type: CreateUserActionTypes.SET_FETCHED_ROLES;
	payload: {
		roles: IItemForGetShortInfo[];
	};
}

interface ISetRole {
	type: CreateUserActionTypes.SET_ROLE;
	payload: {
		role: TCreateUserSelectedItem;
	};
}

interface ISetFetchedCustomers {
	type: CreateUserActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: CreateUserActionTypes.SET_CUSTOMER;
	payload: {
		selectedCustomer: TCreateUserSelectedItem;
	};
}

interface ISetCustomers {
	type: CreateUserActionTypes.SET_CUSTOMERS;
	payload: {
		selectedCustomers: string[];
	};
}

interface ISetFetchedRestaurants {
	type: CreateUserActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: CreateUserActionTypes.SET_RESTAURANTS;
	payload: {
		selectedRestaurants: string[];
	};
}

interface IChangePassword {
	type: CreateUserActionTypes.CHANGE_PASSWORD;
	payload: {
		password: string;
	};
}

interface IChangePasswordConfirm {
	type: CreateUserActionTypes.CHANGE_PASSWORD_CONFIRM;
	payload: {
		passwordConfirm: string;
	};
}

interface ISetDataForSubmit {
	type: CreateUserActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateUser | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateUserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateUserModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateUserActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<IUserEmailValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: CreateUserActionTypes.RESET_FIELDS;
}

export type TCreateUserAction =
	| ISetFile
	| IChangeName
	| IChangeSurName
	| IChangeEmail
	| IChangePhoneNumber
	| ISetFetchedRoles
	| ISetRole
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetCustomers
	| ISetFetchedRestaurants
	| ISetRestaurants
	| IChangePassword
	| IChangePasswordConfirm
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
